import React, {useContext} from 'react';
import {useTranslation} from "react-i18next";
import {ReactComponent as SearchIco} from "../../../images/icons/search.svg";
import ResponsiveComponent from "../Common/ResponsiveComponent";
import {MenuSearchContext} from "../../services/Menu/services/Search/MenuSearchContext";
import AppConfig from "../../services/AppConfig";
import IframeWidget from "../../utils/IframeWidget";

const NavbarSearch = () => {
    const {t} = useTranslation();
    const {setShowSearchBar} = useContext(MenuSearchContext);

    const handleOnClick = () => {
        setShowSearchBar((prevState) => {
            if (!prevState) {
                const scrollToOptions: ScrollToOptions = {top: 0, behavior: "smooth"};

                if (AppConfig.isWidget()) {
                    IframeWidget.scrollTo(scrollToOptions);
                } else {
                    window.scrollTo(scrollToOptions);
                }
            }

            return !prevState
        });
    }

    return (
        <ResponsiveComponent small={<div>
            <button className="btn btn-icon" aria-label={t("modules.menu.field.search_product.title")}
                    onClick={handleOnClick}
            >
                <SearchIco aria-hidden="true"/>
            </button>
        </div>} large={<></>} breakpoint={768}/>
    )
}

export default NavbarSearch;